
export const mutations = {
    STORE_ROLE_MODULES (state, modules) {
        state.rolemodules = modules
    }
}

export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/rolemodules/mutations.js